<template>
  <section class="branches">
    <custom-card description="selecione o modo">
      <div class="d-flex">
        <b-button
          class="flex-grow-1 mr-2"
          variant="outline-primary"
          @click="setMode('delivery')"
        >
          <i class="las la-motorcycle btn-icon mb-2"></i>
          <p>delivery/retirada</p>
        </b-button>
        <b-button
          class="flex-grow-1 ml-2"
          variant="outline-primary"
          @click="setMode('local')"
        >
          <i class="las la-shopping-bag btn-icon mb-2"></i>
          <p>consumo local</p>
        </b-button>
      </div>
    </custom-card>
  </section>
</template>

<script>
import CustomCard from "@/components/Utils/CustomCard.vue";
import { setActiveMode } from "@/helpers/storage";
import { mapGetters } from "vuex";
import { toast } from "@/helpers/toast";
import { getActiveCompany } from "@/helpers/storage";
import moment from "moment";

export default {
  name: "select-mode",
  components: {
    CustomCard
  },
  methods: {
    setMode(mode) {
      setActiveMode(mode);

      this.$router.push("/dashboard");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
